import Highcharts from 'highcharts'

import data from './totals.json';

const defaultPeriods = [
  {
    slug: 'FI',
    name: 'Finland',
  },
  {
    slug: 'SE',
    name: 'Sverige',
  },
  {
    slug: 'NO',
    name: 'Norge',
  },
  {
    slug: 'DK',
    name: 'Danmark',
  },
  {
    slug: 'DE',
    name: 'Tyskland',
  },
  {
    slug: 'UK',
    name: 'Storbritannien',
  },
  {
    slug: 'FR',
    name: 'Frankrike',
  },
  {
    slug: 'IT',
    name: 'Italien',
  }
]

const morePeriods = [
  {
    slug: 'BE',
    name: 'Belgien',
  },
  {
    slug: 'EE',
    name: 'Estland',
  },
  {
    slug: 'AT',
    name: 'Österrike',
  },
  {
    slug: 'BG',
    name: 'Bulgarien',
  },
  {
    slug: 'CH',
    name: 'Schweitz',
  },
  {
    slug: 'CZ',
    name: 'Tjeckien',
  },
  {
    slug: 'ES',
    name: 'Spanien',
  },
  {
    slug: 'HU',
    name: 'Ungern',
  },
  {
    slug: 'LT',
    name: 'Litauen',
  },
  {
    slug: 'LV',
    name: 'Lettland',
  },
  {
    slug: 'ME',
    name: 'Montenegro',
  },
  {
    slug: 'PT',
    name: 'Portugal',
  },
  {
    slug: 'RS',
    name: 'Serbien',
  },
  {
    slug: 'SI',
    name: 'Slovenien',
  },
  {
    slug: 'SK',
    name: 'Slovakien',
  }
]

import './style.scss';

const gray = 'rgb(200, 200, 200)'

Highcharts.setOptions({
  colors: ['#e1005a', '#00b4c8', '#99cc66', '#ff6633', '#666699'],
  lang: {
    numericSymbols: null,
    weekdays: ["söndag", "måndag", "tisdag", "onsdag", "torsdag", "fredag", "lördag"],
    months: ["januari", "februari", "mars", "april", "maj", "juni", "juli", "augusti", "september", "oktober", "november", "december"],
    shortMonths: ["jan", "febr", "mar", "apr", "maj", "jun", "jul", "aug", "sept", "okt", "nov", "dec"],
    thousandsSep: " ",
    decimalPoint: ",",
    contextButtonTitle: "Skriv ut/ladda ner",
    printChart: "Skriv ut",
    downloadPNG: "PNG-bild",
    downloadJPEG: "JPEG-bild",
    downloadPDF: "PDF-fil",
    downloadSVG: "SVG-fil",
    resetZoom: "Nollställ zoom",
    resetZoomTitle: "Nollställ zoom"
  },
  credits: false,
  chart: {
    height: 240,
    style: {
      fontFamily: ['Arial', 'sans-serif'],
    }
  },
  title: {
    align: 'left',
    style: {
      color: '#000',
      fontSize: '18px',
      fontWeight: 'bold',
    },
  },
  subtitle: {
    align: 'left',
    style: {
      fontSize: '14px',
      fontWeight: 'bold',
    }
  },
  plotOptions: {
    series: {
      marker: {
        enabledThreshold: 5,
      },
    },
  },
  tooltip: {
    formatter: function () {
      let text = '<span style="font-size: 10px">Dödsfall vecka ' + (this.x + 1) + '</span><br/>';
      text += '<span style="color:' + this.points[5].color + '">●</span> 2015-2019, ' + this.points[5].series.name + ': <b>'
        + Highcharts.numberFormat(this.points[5].y, -1, ",", "&thinsp;") + '</b>' + '<br/>';

      if (this.points[6]) {
        const difference = (this.points[6].y - this.points[5].y) / this.points[5].y * 100;
        text += '<span style="color:' + this.points[6].color + '">●</span> ' + this.points[6].series.name + ': <b>'
        + Highcharts.numberFormat(this.points[6].y, -1, ",", "&thinsp;") + '</b> ('
        + (difference > 0 ? '+' : '') + Highcharts.numberFormat(difference, 1) + ' %)';
      }
      
      return text;
    },
    useHTML: true,
    shared: true,
  },
  xAxis: {
    lineColor: '#000',
    tickLength: 5,
    title: {
      align: 'low',
      offset: 0,
      y: -20,
      style: {
        fontSize: '12px',
      },
    },
    tickInterval: 18,
    labels: {
      autoRotationLimit: 40,
      padding: 2,
      style: {
        fontSize: '14px',
        color: '#000',
      },
      formatter: function () {
        return this.value + 1;
      }
    },
  },
  yAxis: {
    gridLineColor: '#E6E6E6',
    labels: {
      autoRotationLimit: 40,
      padding: 2,
      style: {
        fontSize: '12px',
        color: '#000',
      },
      align: 'right',
      x: 5,
      y: -3,
    },
    opposite: true,
    title: {
      style: {
        fontSize: '14px',
        color: '#000',
      },
    },
  },
});

const getDeathString = function(extraDeaths) {
  if (extraDeaths >= 3) {
    return 'Total överdödlighet ' + extraDeaths.toLocaleString('sv') + ' %';
  }
  else if (extraDeaths > 0) {
    return 'Låg överdödlighet (' + extraDeaths.toLocaleString('sv') + ' %)';
  }
  else return 'Ingen överdödlighet (' + extraDeaths.toLocaleString('sv') + ' %)';
}

const createChart = function(period, el) {
  const chartDiv = document.createElement('div');
  const extraDeaths = data[period.slug].total_percent;

  chartDiv.className = 'period-chart';
  el.appendChild(chartDiv);
  new Highcharts.Chart(chartDiv, {
    title: {
      text: period.name,
    },
    subtitle: {
      widthAdjust: 0,
      text: getDeathString(extraDeaths),
      style: {
        color: extraDeaths >= 3 ?
          'rgb(236, 91, 96)' :
          'rgb(100,100,100)',
      }
    },
    chart: {
      type: 'line',
    },
    legend: false,
    xAxis: {
      crosshair: true,
      title: {
        text: 'vecka',
      },
    },
    yAxis: {
      title: false,
      min: 0,
    },
    series: [
      {
        data: data[period.slug]['2015'],
        name: '2015',
        color: gray,
      },
      {
        data: data[period.slug]['2016'],
        name: '2016',
        color: gray,
      },
      {
        data: data[period.slug]['2017'],
        name: '2017',
        color: gray,
      },
      {
        data: data[period.slug]['2018'],
        name: '2018',
        color: gray,
      },
      {
        data: data[period.slug]['2019'],
        name: '2019',
        color: gray,
      },
      {
        data: data[period.slug]['avg'],
        name: 'genomsnitt',
        color: 'rgb(100,100,100)',
      },
      {
        data: data[period.slug]['2020'],
        name: '2020',
        color: 'rgb(236, 91, 96)',
        lineWidth: 3,
      },
    ],
  });
}

class App {
  constructor(name) {
    this.url = process.env.BASE_URL;
    this.name = name;
    this.selector = `#app-${name}`;
  }

  mount() {
    const el = document.getElementById(`app-${this.name}`);

    defaultPeriods.forEach((period) => {
      createChart(period, el);
    });

    const btn = document.createElement('button');
    btn.innerHTML = 'Visa fler'
    btn.className = 'yddviz-button';
    el.appendChild(btn);

    btn.addEventListener ('click', (event) => {
      morePeriods.forEach((period) => {
        createChart(period, el);
      });
      event.target.remove();
    });
  }
}

export default App;
